import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "@/content";

export default function About() {
  return (
    <div data-testid="page-about" className="bg-white">
      <section className="pt-[120px] pb-16 lg:pb-24">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="grid grid-cols-12 gap-10 items-end">
            <div className="col-span-12 lg:col-span-8">
              <p className="overline">About Crystal Purdue</p>
              <h1 className="display mt-6 text-[44px] md:text-[120px]">
                For twenty years<br/>I didn't know<br/>I could <em className="font-serif text-[var(--ic-accent)]">choose me</em>.
              </h1>
            </div>
            <div className="col-span-12 lg:col-span-4">
              <p className="font-sans text-[17px] leading-[1.75] text-black/75">
                I'm Crystal Purdue &mdash; speaker, coach, mother, and founder of The I Choose
                Movement. A community of people choosing to be participants in their own lives
                and create the lives they actually want to live.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="hairline-b">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-12">
          <div className="zoom-img-wrap relative overflow-hidden border border-[var(--ic-line)] aspect-[16/9] bg-[var(--ic-warm)]">
            <img src={BRAND.images.eventTee} alt="A mother and her daughter wearing I Choose Movement shirts at an event" className="zoom-img absolute inset-0 w-full h-full object-cover object-[center_30%]" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8 bg-gradient-to-t from-black/65 to-transparent">
              <p className="overline text-white/85">I Choose Financial Freedom</p>
              <p className="font-serif text-white text-[22px] md:text-[28px] mt-1 max-w-2xl leading-tight">
                Choosing me allowed me to choose my children. That's the legacy I'm building.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-12 gap-10">
          <aside className="col-span-12 lg:col-span-3">
            <p className="overline sticky top-28">Her Story</p>
          </aside>
          <div className="col-span-12 lg:col-span-8 lg:col-start-5 space-y-10 font-sans text-[17px] leading-[1.85] text-black/85">
            <div>
              <h2 className="font-serif text-[34px] md:text-[44px] leading-[1.05] tracking-tight text-black">Twenty years of not knowing I could choose me.</h2>
              <p className="mt-6">
                I was married for twenty years, and for twenty years I did not know that I was
                allowed to choose myself. I poured into a marriage, into a home, into everyone
                around me &mdash; and quietly assumed that choosing me was somewhere between
                impossible and selfish. It was neither. I just didn't have the language for it yet.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-[34px] md:text-[44px] leading-[1.05] tracking-tight text-black">The day I learned I could choose me.</h2>
              <p className="mt-6">
                Eventually I had to be honest with myself. The moment I understood that I was
                allowed to choose me &mdash; that's the moment I found my power. Not in any
                leaving. In the <em>choosing</em>. That choice didn't just give me back to
                myself. It gave me back to my children, too &mdash; Christian, Caris,
                and James. Choosing me made me a better mother, sister, daughter &mdash;
                and a better presence in my community.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-[34px] md:text-[44px] leading-[1.05] tracking-tight text-black">God let me lose it all &mdash; and recover.</h2>
              <p className="mt-6">
                God allowed me to lose it all. And He also allowed me to recover. I am forever
                grateful for the opportunities He has given me on the other side of that loss
                &mdash; the voice, the platform, the people, the purpose. Every room I walk
                into now is a room I never would have entered if I hadn't first been brave
                enough to choose myself.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-[34px] md:text-[44px] leading-[1.05] tracking-tight text-black">Why I built The I Choose Movement.</h2>
              <p className="mt-6">
                I am passionate about going into rooms &mdash; classrooms, sanctuaries,
                boardrooms, living rooms &mdash; and reminding people that you have a right
                to choose. You don't have to allow life to choose for you. You can choose
                <em> in </em> it.
              </p>
              <p className="mt-6">
                The I Choose Movement is where we are being participants in our own lives.
                Where we are creating the lives we want to live, on purpose. Where we are
                choosing &mdash; and choosing &mdash; until our I Choose choose us back.
              </p>
            </div>

            <div className="hairline pt-10 mt-4">
              <p className="font-serif text-[28px] md:text-[36px] leading-[1.15] text-black border-l-2 border-black pl-6">
                "I want people to choose to create the life they want to live &mdash; and
                live it."
              </p>
              <p className="overline mt-6">— Crystal Purdue, Founder</p>
            </div>

            <div className="flex flex-wrap gap-4 pt-6">
              <Link to="/speaking#inquiry" data-testid="about-cta-speak" className="btn-ink">Book Crystal to Speak <ArrowUpRight size={16}/></Link>
              <Link to="/coaching" data-testid="about-cta-coach" className="btn-ghost">Explore Coaching</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
